import * as React from "react";
import { Search } from "lucide-react";
import { Input } from "../ui/input";
import { cn } from "../../lib/utils";

export interface EDSSearchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  onSearch?: (value: string) => void;
  className?: string;
}

const EDSSearch = React.forwardRef<HTMLInputElement, EDSSearchProps>(
  ({ placeholder = "Search...", onSearch, className, ...props }, ref) => {
    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter" && onSearch) {
        onSearch(e.currentTarget.value);
      }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (props.onChange) {
        props.onChange(e);
      }
    };

    return (
      <div className={cn("relative", className)}>
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
        <Input
          ref={ref}
          type="text"
          placeholder={placeholder}
          className="pl-10 pr-3"
          onKeyPress={handleKeyPress}
          onChange={handleChange}
          {...props}
        />
      </div>
    );
  }
);

EDSSearch.displayName = "EDSSearch";

export { EDSSearch };
